// src/pages/Home.tsx
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import WhatIDoSection from '../components/WhatIDoSection';
import ExperienceHighlights from '../components/ExperienceHighlights';
import SelectedWorkPreview from '../components/SelectedWorkPreview';
import ProjectCallToAction from '../components/ProjectCallToAction';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <WhatIDoSection />
      <ExperienceHighlights />
      <SelectedWorkPreview />
      <ProjectCallToAction />
      <Footer />
    </>
  );
};

export default Home;
